import React from 'react'
import { Omny, OmnyProps } from '../../../publication/Embed/web/Omny'
import { createRegisterableComponent } from '@news-mono/web-common'

export interface OmnyRouteProps extends OmnyProps {}

export const OmnyRegistration = createRegisterableComponent(
    'omny-web',
    (props: OmnyRouteProps) => {
        return (
            <Omny
                height={props.height}
                link={props.link}
                width={props.width}
                verticalSpacing={props.verticalSpacing}
            />
        )
    },
)
